module.exports = __webpack_public_path__ + "static/media/404-resend.26ac32d3.svg";